import moment from "moment";
import { Badge, CopyButton, CurrencyDisplay } from "../../../components";
import { appConfig } from "../../../configs";

import {
  IViewBatchTransfer,
  StatusColors,
} from "../../../interfaces-and-types";
import {
  getBatchTransferStatusIndicator,
  truncateStringWithEllipsis,
} from "../../../utils";

export const transferBatchesDisplayFormatter = (item: IViewBatchTransfer) => {
  const statusIndicator: { statusText: string; statusType: StatusColors } =
    getBatchTransferStatusIndicator(item);

  return {
    ...item,

    // NOTE: causes routing errors to details b/c "batch_reference" which is used to navigate is replaced with below object
    batch_reference_display: (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="batchref-text modal-header--title">
          <span title={item.batch_reference}>
            {truncateStringWithEllipsis(item.batch_reference, 25)}
          </span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            name="copy-reference-button"
            stringToCopy={item.batch_reference}
            iconDescription="copy reference"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    total_amount: (
      <CurrencyDisplay
        currencyOrSymbol={item.source_currency}
        amount={item.total_amount}
      />
    ),
    total_fee: (
      <CurrencyDisplay
        currencyOrSymbol={item.source_currency}
        amount={item.total_fee}
      />
    ),
    title: (
      <span
        className="transfer-description truncate-text--ellipsis"
        title={item.title}
      >
        {truncateStringWithEllipsis(item.title, 40)}
      </span>
    ),
    // description: (
    //   <span
    //     className="transfer-description truncate-text--ellipsis"
    //     title={item.description}
    //   >
    //     {truncateStringWithEllipsis(item.description, 40)}
    //   </span>
    // ),
    statusBadge: (
      <Badge
        text={statusIndicator.statusText}
        statusColor={statusIndicator.statusType}
      />
    ),
    created_at: (
      <span className="date--oneline">
        {moment(item.created_at).format(appConfig.dateTimeFormat)}
      </span>
    ),
    // more: <OverflowMenuDropDown />,
  };
};
